import React, {useEffect, useState} from 'react';
import {
    Affix,
    Avatar,
    Button,
    Card,
    Checkbox,
    Divider,
    Menu,
    message,
    Modal,
    Popover,
    Radio,
    Space,
    Switch
} from "antd";

import dayjs from "dayjs";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import {Header} from "antd/es/layout/layout";
import {UserOutlined} from "@ant-design/icons";


const BuyVip_ui=()=>{

    const [value, setValue] = useState('11'); // 默认选中的


    const [checkbox_buy, setcheckbox_buy] = useState(true); // 默认选中的
    const data_time=dayjs().unix();
    const onChange = (e:any) => {
        console.log('选中的', e.target.value);
        setValue(e.target.value);
    };

    const Admin_log_out = () => {


        Cookies.remove('userToken_chattool')
        Cookies.remove('group')
        let time = dayjs().unix();
        navigate('/login?return_url=/admin/keyclick')

        return (
            console.log("111")

        );


    }

const [pay_method,setpay_method]=useState('wxpay')

    const buy_onchange=(e1:any)=>{


        setValue(e1)
        setfetch_select_price_info_select_log({message: 'click', value: '', time: data_time})



        setfetch_select_price_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }

const navigate=useNavigate();

    useEffect(() => {


        setget_products_select_log({message:'d',value:'',time:data_time})
        setfetch_vipinfo_select_log({message:'1',value:'',time:data_time})

        setfetch_select_price_info_select_log({message:'1',value:'',time:data_time})

    }, []);

    const [pay_model_modal_open, setpay_model_modal_open] = useState(false)

    const [pay_model_select_info, setpay_model_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [pay_model_select_log, setpay_model_select_log] = useState({message: '', value: '', time: 0})
    const pay_model = (e1: any) => {

        window.open('https://api.jinxiaocun.leytcn.com/vendor/alipaysdk/openapi/v2/aop/test/ddd.php?key=111.00')
        setpay_model_select_log({message: 'click', value: '', time: data_time})

        setpay_model_modal_open(true);

        setpay_model_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setpay_model_modal_oncancel = () => {

        setpay_model_modal_open(false);
    }


    const [pay_model_modal_next_button_select_log,setpay_model_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const pay_model_modal_next_button = () => {

        let data_time=dayjs().unix();

        setpay_model_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_pay_model,setreturn_data_pay_model]=useState({});

    const pay_model_body = new FormData();


    pay_model_body.append('id', pay_model_select_info.value1);

    pay_model_body.append('userToken', String(Cookies.get('userToken_codegenerate')));

    pay_model_body.append('time', String(pay_model_modal_next_button_select_log.time));

    pay_model_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('undefined', {


                method: 'POST',
                body: pay_model_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setpay_model_modal_open(false)

                    setreturn_data_pay_model(return_data);
               //     setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if(pay_model_modal_next_button_select_log.message!==''){

            data_async();
            setpay_model_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [pay_model_modal_next_button_select_log]);


    const [buy_phone_pay_select_info, setbuy_phone_pay_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [buy_phone_pay_select_log, setbuy_phone_pay_select_log] = useState({message: '', value: '', time: 0})
    const buy_phone_pay = (e1:any,e2:any,buy_method:any) => {

if(checkbox_buy){

    console.log('pay_method'+pay_method)

    switch (true){


        case pay_method==='wxpay':
            message.info('暂时不支持微信支付')
break;

        case pay_method==='alipay':


            setbuy_phone_pay_select_log({message: 'click', value: '', time: data_time})

            setbuy_phone_pay_select_info({value1: e1, value2: 'default_address.uuid', value3: 'select_send_date_time_finish.value1', time: data_time})


            break;



    }




}else {

    message.info('请先阅读并同意条款')
}






    }


    const [return_data_buy_phone_pay,setreturn_data_buy_phone_pay]=useState({});

    const buy_phone_pay_body = new FormData();





    buy_phone_pay_body.append('pay_node', value);

    buy_phone_pay_body.append('pay_method', pay_method);

    buy_phone_pay_body.append('id', buy_phone_pay_select_info.value1);
    buy_phone_pay_body.append('buy_method', 'alipay');


    buy_phone_pay_body.append('userToken', String(Cookies.get('userToken_chattool')));
    buy_phone_pay_body.append('day', '1');

    buy_phone_pay_body.append('time', String(buy_phone_pay_select_info.time));


    buy_phone_pay_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/buyshop/insert_buyshop.php', {


                method: 'POST',
                body: buy_phone_pay_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

                    message.success(return_data.value)
//添加成功，无需提示
                    /*    Toast.show({
                          content: return_data.value,
                          duration: 2000,
                          position: 'bottom',
                      });*/
                    let data_time = dayjs().unix();

                    setreturn_data_buy_phone_pay(return_data);

                    setpay_model_modal_open(true);

           /*         navigate('/buyshop_next?merchant_uuid='+'merchant_uuid'+'&order_number='+return_data.info.order_number+'&buy_method='+return_data.info.buy_method+'&return_url='+String(return_url))
*/
                    // navigate('/buyshop_next?merchant_uuid='+merchant_uuid+'&order_number='+return_data.info.order_number+'&buy_method='+return_data.info.buy_method+'&return_url='+String(return_url), {replace: true})
                  //   window.location.href=('https://api.shop.leytcn.com/function_api/home/buyshop/buyalipay/buy_alipay.php?merchant_uuid='+String(Cookies.get('merchant_uuid'))+'&order_number='+String(return_data.info.order_number));

                     window.open('https://api.chatv2.leytcn.com/admin/buyshop/buy_alipay.php?order_number='+String(return_data.info.order_number))
                    // setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:
                    message.info(return_data.value)
                 /*   Toast.show({
                        content: return_data.value,
                        duration: 2000,
                        position: 'bottom',
                    });*/


                    break


                case 4018:

                    setTimeout(() => {
                        message.error(return_data.value)
                        /*      setbug_post_finish_button_loading(false);*/
                       /* Toast.show({
                            content: return_data.value,
                            duration: 2000,
                            position: 'bottom',
                        });*/
                    }, 300)

                    navigate('/login')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                   /*     Toast.show({
                            content: return_data.value,
                            duration: 2000,
                            position: 'bottom',
                        });*/
                    }, 300)

                    navigate('/login')


                    break


            }

        }


        if(buy_phone_pay_select_log.message!==''){

            data_async();
            setbuy_phone_pay_select_log({message:'',value:'',time:0})
        }
    }, [buy_phone_pay_select_log]);






    const [get_products_select_info, setget_products_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [get_products_select_log, setget_products_select_log] = useState({message: '', value: '', time: 0})
    const get_products = (e1: any) => {

        setget_products_select_log({message: 'click', value: '', time: data_time})



        setget_products_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_get_products,setreturn_data_get_products]=useState({
        "message": 2000,
        "value": "获取成功",
        "info": [
            {
                "id": "1",
                "title": "聊天助手会员",
                "sub_title": "1个月使用期限",
                "price": "2.50",
                "joinCouponTotalPrice": null,
                "totalPrice": "2.50",
                "market_price": null,
                "vip_price": null,
                "barcode": null,
                "hod": null,
                "value": "1",
                "node": null,
                "uuid": "11",
                "inventory": null,
                "qualification_card_uuid": null,
                "parent_uuid": "0",
                "created": "0",
                "updated": null,
                "status": "en",
                "status_type": null,
                "images_json": null,
                "image": null,
                "region_id": null,
                "buy_max_num": null
            },
            {
                "id": "2",
                "title": "聊天助手会员",
                "sub_title": "1个年使用期限",
                "price": "30.00",
                "joinCouponTotalPrice": null,
                "totalPrice": "2.50",
                "market_price": "19.90",
                "vip_price": null,
                "barcode": null,
                "hod": null,
                "value": "1",
                "node": null,
                "uuid": "11",
                "inventory": null,
                "qualification_card_uuid": null,
                "parent_uuid": "0",
                "created": "0",
                "updated": null,
                "status": "en",
                "status_type": null,
                "images_json": null,
                "image": null,
                "region_id": null,
                "buy_max_num": null
            }
        ]
    });

    const get_products_body = new FormData();


    get_products_body.append('id', get_products_select_info.value1);

    get_products_body.append('userToken', String(Cookies.get('userToken_chattool')));

    get_products_body.append('time', String(get_products_select_info.time));

    get_products_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/vip_products/fetch/fetch_products.php', {


                method: 'POST',
                body: get_products_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_get_products(return_data);

             //       setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(get_products_select_log.message!==''){

            data_async();
            setget_products_select_log({message:'',value:'',time:0})
        }
    }, [get_products_select_log]);






    const [fetch_select_price_info_select_info, setfetch_select_price_info_select_info] = useState({value1: '11', value2: '', value3: '', time: 0})

    const [fetch_select_price_info_select_log, setfetch_select_price_info_select_log] = useState({message: '', value: '', time: 0})
    const fetch_select_price_info = (e1: any) => {

        setfetch_select_price_info_select_log({message: 'click', value: '', time: data_time})



        setfetch_select_price_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_select_price_info,setreturn_data_fetch_select_price_info]=useState({
        "message": 2000,
        "value": "获取成功",
        "info": {
            "id": "1",
            "title": "聊天助手会员",
            "sub_title": "1个月使用期限",
            "price": "2.50",
            "joinCouponTotalPrice": null,
            "totalPrice": "2.50",
            "market_price": null,
            "vip_price": null,
            "barcode": null,
            "hod": null,
            "value": "1",
            "node": null,
            buy_vip_end_time:0,
            "uuid": "11",
            "inventory": null,
            "qualification_card_uuid": null,
            "parent_uuid": "0",
            "created": "0",
            "updated": null,
            "status": "en",
            "status_type": null,
            "images_json": null,
            "image": null,
            "region_id": null,
            "buy_max_num": null
        }
    });

    const fetch_select_price_info_body = new FormData();


    fetch_select_price_info_body.append('uuid', fetch_select_price_info_select_info.value1);

    fetch_select_price_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_select_price_info_body.append('time', String(fetch_select_price_info_select_info.time));

    fetch_select_price_info_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/vip_products/fetch/fetch_select_price_info.php', {


                method: 'POST',
                body: fetch_select_price_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_select_price_info(return_data);

                 //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(fetch_select_price_info_select_log.message!==''){

            data_async();
            setfetch_select_price_info_select_log({message:'',value:'',time:0})
        }
    }, [fetch_select_price_info_select_log]);





    const [fetch_vipinfo_select_info, setfetch_vipinfo_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_vipinfo_select_log, setfetch_vipinfo_select_log] = useState({message: '', value: '', time: 0})
    const fetch_vipinfo = (e1: any) => {

        setfetch_vipinfo_select_log({message: 'click', value: '', time: data_time})



        setfetch_vipinfo_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_vipinfo,setreturn_data_fetch_vipinfo]=useState({
        "message": 2000,
        "value": "获取成功",
        "info": {
            "id": "1",
            "uuid": "1",
            "title": "1",
            "status": "en",
            "type": "专业",
            "value": "",
            "vip_end_time": 0,
            "is_del": "0",
            "country_uuid": "341eea77-f9ef-4157-a695-05c0f9b70761"
        }
    });

    const fetch_vipinfo_body = new FormData();


    fetch_vipinfo_body.append('uuid', fetch_vipinfo_select_info.value1);

    fetch_vipinfo_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_vipinfo_body.append('time', String(fetch_vipinfo_select_info.time));

    fetch_vipinfo_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/vip_products/fetch/fetch_vipinfo.php', {


                method: 'POST',
                body: fetch_vipinfo_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                   /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_vipinfo(return_data);

                   // setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(fetch_vipinfo_select_log.message!==''){

            data_async();
            setfetch_vipinfo_select_log({message:'',value:'',time:0})
        }
    }, [fetch_vipinfo_select_log]);


    const pay_type_onchange=(e1:any)=>{


        setpay_method(e1.target.value)
        console.log(e1.target.value)
    }


    return (
        <div style={{display:'flex',flexDirection:'column',padding:'20px'}}>
            <Affix offsetTop={0}>
                <Header style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    background: "#FFFFFF",
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    zIndex: 1000, // Ensure Header is on top

                }}>

                    <h3 style={{color: "#000000", margin: 0}}>后台管理</h3>

                    <div style={{textAlign: 'right'}}>

                        <Popover arrow={false} placement="topRight" content={<div style={{}}>

                            <Menu>

                                <Menu.Item key="0">
                                    <label  onClick={()=>(window.open('/userinfo'))}>
                                        个人中心
                                    </label>
                                </Menu.Item>
                                <Menu.Item key="1">
                                    <label   onClick={Admin_log_out}>
                                        退出登录
                                    </label>
                                </Menu.Item>
                            </Menu>

                        </div>} title="Title">
                            <Avatar size={32} icon={<UserOutlined />} />
                        </Popover>

                    </div>
                </Header>
            </Affix>



            <div style={{height:60}}>


            </div>

            <div style={{display:'flex',alignContent:'center',justifyContent:'center',width:'100%',minWidth:1080,overflowY:'auto'}}>


            <Card style={{}}>



                    <div style={{display:'flex',flexDirection:'column'}}>

                        <label style={{fontSize:15,fontWeight:'bold'}}>当前状态</label>

                        <label>会员信息：{return_data_fetch_vipinfo.info.type}</label>

                        <label>有效期至：{dayjs.unix(return_data_fetch_vipinfo.info.vip_end_time).format('YYYY-MM-DD')}</label>
                    </div>





            <div style={{display:'flex',flexDirection:'column',marginTop:20}}>
                <label style={{fontSize:15,fontWeight:'bold'}}>购买</label>

                <div style={{ display: 'flex',marginTop:20}}>

                        <Space >

                            {return_data_get_products.message!==2000?<></>:return_data_get_products.info.map((item1:any)=>(

                                <Card size={'small'}
                                      hoverable
                                      style={{ width: 180 }}
                                    /*     onMouseEnter={() => setValue(100)}*/
                                      onClick={() => buy_onchange(item1.uuid)}
                                      className={value === item1.uuid ? 'active-card' : ''}
                                >
                                    <div style={{display:'flex',flexDirection:'column'}}>


                                        <label style={{color:value === item1.uuid?'#1890ff':''}}>
                                            {item1.value}
                                        </label>

                                        <label>{item1.market_price!==null?<div><label style={{color:value === item1.uuid?'#1890ff':''}}>¥ <label style={{fontSize:23,fontWeight:'bold'}}>{item1.market_price}</label></label> <label style={{ color:value === item1.uuid?'#1890ff':'',textDecoration: 'line-through',marginLeft:5 }}>¥ {item1.price}</label></div>:            <label style={{color:value === item1.uuid?'#1890ff':''}}>¥ <label style={{fontSize:23,fontWeight:'bold'}}>{item1.price}</label></label>
                                        }</label>


                                    </div>

                                </Card>
                            ))}



                        </Space>

                </div>





            </div>

            <div style={{display:'flex',flexDirection:'column',marginTop:20}}>

                <label style={{fontSize:15,fontWeight:'bold'}}>支付方式</label>


                <div style={{ display: 'flex',marginTop:20}}>

                    <Radio.Group defaultValue={'wxpay'} onChange={(e)=>pay_type_onchange(e)}>

                        <Radio value="wxpay">微信支付</Radio>
                        <Radio value="alipay">支付宝支付</Radio>

                    </Radio.Group>
                </div>


            </div>
                <div style={{display:'flex',flexDirection:'column',marginTop:20}}>

                    <label style={{fontSize:15,fontWeight:'bold'}}>您选择的方</label>


                    {return_data_fetch_select_price_info.message!==2000?<></>:<>







                        <label style={{marginTop:10}}>价格： <label>{return_data_fetch_select_price_info.info.market_price!==null?<label >¥ <label style={{}}>{return_data_fetch_select_price_info.info.market_price}/{return_data_fetch_select_price_info.info.value}</label></label>:            <label style={{}}>¥ <label style={{}}>{return_data_fetch_select_price_info.info.price}/{return_data_fetch_select_price_info.info.value}</label></label>
                        }</label> </label>


                        <label style={{marginTop:10}}>到期时间：{dayjs.unix(return_data_fetch_select_price_info.info.buy_vip_end_time).format('YYYY-MM-DD')}</label>

                    </>}

                    <Divider/>


                    <label style={{marginTop:10}}>订单金额： <label>{return_data_fetch_select_price_info.info.market_price!==null?<label style={{fontSize:18,fontWeight:'bold'}}>¥<label style={{fontSize:23,fontWeight:'bold'}}>{return_data_fetch_select_price_info.info.market_price}</label></label>:            <label style={{fontSize:18,fontWeight:'bold'}}>¥<label style={{fontSize:23,fontWeight:'bold'}}>{return_data_fetch_select_price_info.info.price}</label></label>
                    }</label></label>

                    <Button style={{marginTop:10}} onClick={()=>buy_phone_pay('','','')}>确认付款</Button>

                    <div style={{display:'flex',padding:10}}>
                        <Checkbox defaultChecked={checkbox_buy} onChange={(e)=>setcheckbox_buy(e.target.checked)}></Checkbox>
                        <label style={{marginLeft:10}}>同意并接受聊天助手付费版服务协议和聊天助手隐私政策
                            *含自动续费条款</label>

                    </div>

                </div>
            </Card>


                <Card style={{marginLeft:10}}>


                <div style={{display:'flex',flexDirection:'column',width:150}}>

                    <label style={{fontSize:15,fontWeight:'bold'}}>vip权益</label>

                    <label style={{marginTop:10}}> 1、无限制创建分组</label>
                    <label style={{marginTop:10}}> 2、无限制创建商品</label>
                    <label style={{marginTop:10}}> 3、无话术添加限制</label>
                    <label style={{marginTop:10}}> 4、无限制子账号</label>
                </div>

                </Card>
            </div>




            <Modal open={pay_model_modal_open} onCancel={setpay_model_modal_oncancel} footer={null} title={'订单是否已支付？'}>


                <Button onClick={pay_model_modal_next_button}>

                    已支付
                </Button>


                <Button style={{marginLeft:10}} >

                    未支付
                </Button>


            </Modal>




        </div>
    )
}
export default BuyVip_ui;